module.exports = __webpack_public_path__ + "static/js/upload worker.ad7c0e6a.chunk.worker.js"